@if (initialized) {

 <div class="mx-auto p-2" style="max-width: 45rem;">
   <div class="text-center mb-6">
     <div class="text-color text-3xl font-semibold mb-2">Adresse hinzufügen</div>
     <span class="text-color-secondary text-sm">Teile uns hier deine Anschrift mit</span>
   </div>
  <div [formGroup]="formGroup">
    <div class="">
      <div class="grid">

        <div class="col-12">
          <div class="grid formgrid p-fluid">
            <div class="field col-12">
              <label for="address" class="font-medium text-900">Adresse suchen</label>
              <input class="w-full" [disabled]="false" pInputText #shipAddress id="address"
                name="address" required autocomplete="off"/>
            </div>
          </div>
        </div>


        <div class="col-12">
          <div class="grid formgrid p-fluid">
            <div class="field md:col-6 col-12">
              <label for="addressStreet" class="font-medium text-900">Straße<span class="text-red-500">*</span></label>
              <input id="addressStreet" formControlName="addressStreet" type="text" pInputText>
            </div>

            <div class="field md:col-6 col-12">
              <label for="addressStreetNumber" class="font-medium text-900">Hausnummer<span class="text-red-500">*</span></label>
              <input id="addressStreetNumber" formControlName="addressStreetNumber" type="text" pInputText>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="grid formgrid p-fluid">
            <div class="field col-12">
              <label for="addressLine2" class="font-medium text-900">Addresszusatz</label>
              <input id="addressLine2" formControlName="addressLine2" type="text" pInputText>
            </div>
          </div>
        </div>


        <div class="col-12">
          <div class="grid formgrid p-fluid">
            <div class="field md:col-6 col-12">
              <label for="addressPostalCode" class="font-medium text-900">Postleizahl<span class="text-red-500">*</span></label>
              <input id="addressPostalCode" formControlName="addressPostalCode" type="text" pInputText>
            </div>

            <div class="field md:col-6 col-12">
              <label for="addressCity" class="font-medium text-900">Stadt<span class="text-red-500">*</span></label>
              <input id="addressCity" formControlName="addressCity" type="text" pInputText>
            </div>
          </div>
        </div>




        </div>
      </div>
    </div>

  <div class="flex justify-content-between col-12 py-4">
    <div>
      <p-button [disabled]="busy" (click)="navigatePreviousStep(2)"
                label="Zurück" severity="secondary" [text]="true"
                iconPos="left" icon="pi pi-arrow-left">
      </p-button>
    </div>

    <div>
<!--      <p-button [disabled]="!isFormValid()" (click)="updateRegistration()" label="weiter" icon="pi pi-arrow-right" iconPos="right"></p-button>-->
      <app-button [disabled]="!isFormValid()"
                  [busy]="busy"
                  (onClick)="updateRegistration()">
      </app-button>
    </div>
  </div>
 </div>
}
